/* eslint-disable */

const logger = (store) => (next) => (action) => {
    const logType = action.type;
    const logInfo = action;
    const result = next(action);
    console.groupCollapsed(action.type);
    console.info('dispatching', action);
    console.log('next state', store.getState());
    console.groupEnd();
    return result;
};

export default logger;
